import React from 'react'
import PartnerBanner from './partners'
import * as E from '../elementor'
import parse from 'html-react-parser'
import SmoothScrollLink from './transition/smooth-scroll-link'

interface OneColHeroProps {
  section?: E.Section
}

const OneColumnHero = ({ section }: OneColHeroProps) => {
  const { heading = [], textEditor = [], button = [], video = [] } = (section != null) ? E.collect(section) : {}
  const partnerSection = section?.cols[0].elements.find(e => e instanceof E.Section) as unknown as E.Section
  const ctaIsScrollLink = button[0]?.link !== undefined && button[0]?.link.includes('#')

  return (
    <>
    <div className='one-column-hero-background'></div>
    <header className='one-column-hero'>
      <div className='hero-content'>
        <h1 className='hero-headline'>
          {parse(heading[0]?.title || '')}
        </h1>
        <p className='hero-subheadline'>
          {parse(textEditor[0]?.text() || '')}
        </p>
        <div className='hero-cta-wrapper'>
          {button[0] ?
            ctaIsScrollLink ? 
            <div><SmoothScrollLink offset={0} link_id={button[0].button_css_id || ''} offsetMobile={0} id={button[0].link as string}><button className='rula-button'>{button[0].text || 'Get started'}</button></SmoothScrollLink></div> :
            <div>
              <a
                id={button[0]?.button_css_id || ''}
                href={button[0]?.link}
              >
                <button className='rula-button'>{button[0]?.text || 'Get Started'}</button>
              </a>
            </div> : null}
          {button[1] ?
            <div className='link-container'>
              <SmoothScrollLink
                id={button[1]?.link || '#how-it-works'}
                className='rula-secondary-button'
                link_id={button[1]?.button_css_id}
                offset={100}
                offsetMobile={75}
              >
                {button[1]?.text}
              </SmoothScrollLink>
            </div> : null}
        </div>
        <video className='hero-video' poster={video[0]?.poster_url} autoPlay muted loop playsInline>
          <source src={video[0]?.hosted_url} type='video/mp4' />
          <source src={video[1]?.hosted_url} type='video/webm' />
        </video>
      </div>
      <PartnerBanner section={partnerSection} theme='column' />
    </header>
    </>
  )
}

export default OneColumnHero
